import React from "react";
import {
    FaFacebookF,
    FaInstagram,
    FaTwitter,
    FaYoutube,
    FaLinkedinIn,
    FaWhatsapp,
} from "react-icons/fa";
import "../css/FloatingSocialMenu.css";

function FloatingSocialMenu() {
    // Social links list configuration
    const socialLinks = [
        {
            name: "WhatsApp",
            icon: <FaWhatsapp className="floater-icon" />,
            url: "https://wa.me/916290425024?text=Hello%20Fixovera%20Team,%20I%20would%20like%20to%20know%20more%20about%20your%20services.",
            className: "floater-whatsapp"
        },
        {
            name: "Facebook",
            icon: <FaFacebookF className="floater-icon" />,
            url: "#",
            className: "floater-facebook"
        },
        {
            name: "Instagram",
            icon: <FaInstagram className="floater-icon" />,
            url: "#",
            className: "floater-instagram"
        },
        {
            name: "X (Twitter)",
            icon: <FaTwitter className="floater-icon" />,
            url: "#",
            className: "floater-twitter"
        },
        {
            name: "YouTube",
            icon: <FaYoutube className="floater-icon" />,
            url: "#",
            className: "floater-youtube"
        },
        {
            name: "LinkedIn",
            icon: <FaLinkedinIn className="floater-icon" />,
            url: "#",
            className: "floater-linkedin"
        }
    ];
    return (
        <div className="crest-floater-right-container">
            {/* Header / Handle Tag matching style */}
            {/* <div className="crest-floater-header-tag" title="Connect With Us">
                <FaShareAlt className="floater-header-icon" />
                <span className="floater-header-label">Connect</span>
            </div> */}

            {/* Mapped Social Buttons */}
            {socialLinks.map((social, index) => (
                <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`crest-floater-right-btn ${social.className}`}
                    title={social.name}
                >
                    {/* <span className="floater-label">{social.name}</span> */}
                    {social.icon}
                </a>
            ))}
        </div>
    );
}

export default FloatingSocialMenu;